import { Injectable, signal } from '@angular/core';
import { HelpTopicId } from '../models/help.model';

@Injectable({ providedIn: 'root' })
export class HelpService {
  private readonly _open = signal(false);
  private readonly _topic = signal<HelpTopicId | null>(null);

  readonly isOpen = this._open.asReadonly();
  readonly topic = this._topic.asReadonly();

  open(topic: HelpTopicId): void {
    this._topic.set(topic);
    this._open.set(true);
  }

  close(): void {
    this._open.set(false);
    this._topic.set(null);
  }
}
